import { EventEmitter, Component, Input, Output, ViewChild, HostListener, NgModule } from '@angular/core';
import * as SimpleMDE from 'simplemde';
import { toggleBold, toggleItalic, toggleHeadingSmaller, drawTable, toggleUnorderedList, toggleOrderedList, drawHorizontalRule, toggleBlockquote, toggleCodeBlock, toggleSideBySide, toggleFullScreen } from 'simplemde';
import { Observable } from 'rxjs';
import { CommonModule } from '@angular/common';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/editor/editor-config.model.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
import * as ɵngcc0 from '@angular/core';

const _c0 = ["body"];
function ISimpleMdeConfig() { }
if (false) {
    /** @type {?} */
    ISimpleMdeConfig.prototype.actions;
    /**
     * @param {?} text
     * @param {?=} preview
     * @return {?}
     */
    ISimpleMdeConfig.prototype.previewRenderer = function (text, preview) { };
}
/**
 * @record
 */
function ISimpleMdeToolBarCustomAction() { }
if (false) {
    /** @type {?} */
    ISimpleMdeToolBarCustomAction.prototype.name;
    /** @type {?} */
    ISimpleMdeToolBarCustomAction.prototype.title;
    /** @type {?} */
    ISimpleMdeToolBarCustomAction.prototype.icon;
    /**
     * @param {?} selectedText
     * @return {?}
     */
    ISimpleMdeToolBarCustomAction.prototype.action = function (selectedText) { };
    /**
     * @return {?}
     */
    ISimpleMdeToolBarCustomAction.prototype.simpleMdeAction = function () { };
}
const ɵ0 = /**
 * @param {?} s
 * @return {?}
 */
(s) => s, ɵ1 = /**
 * @param {?} s
 * @return {?}
 */
s => s, ɵ2 = /**
 * @param {?} s
 * @return {?}
 */
s => s;
/** @type {?} */
const DefaultFontActions = [
    {
        name: 'bold',
        simpleMdeAction: toggleBold,
        icon: 'fa-bold',
        // Look for a suitable icon
        title: 'Bold',
        action: (ɵ0)
    },
    {
        name: 'italic',
        simpleMdeAction: toggleItalic,
        icon: 'fa-italic',
        // Look for a suitable icon
        title: 'Italic',
        action: (ɵ1)
    },
    {
        name: 'heading',
        simpleMdeAction: toggleHeadingSmaller,
        icon: 'fa-header',
        // Look for a suitable icon
        title: 'Heading',
        action: (ɵ2)
    },
];
const ɵ3 = /**
 * @param {?} s
 * @return {?}
 */
s => s, ɵ4 = /**
 * @param {?} s
 * @return {?}
 */
s => s, ɵ5 = /**
 * @param {?} s
 * @return {?}
 */
s => s;
/** @type {?} */
const DefaultNumerationActions = [
    {
        name: 'table',
        simpleMdeAction: drawTable,
        icon: 'fa-table',
        // Look for a suitable icon
        title: 'Insert Table',
        action: (ɵ3)
    },
    {
        name: 'unordered-list',
        simpleMdeAction: toggleUnorderedList,
        icon: 'fa-list-ul',
        // Look for a suitable icon
        title: 'Generic List',
        action: (ɵ4)
    },
    {
        name: 'ordered-list',
        simpleMdeAction: toggleOrderedList,
        icon: 'fa-list-ol',
        // Look for a suitable icon
        title: 'Numbered List',
        action: (ɵ5)
    },
];
const ɵ6 = /**
 * @param {?} selectedText
 * @return {?}
 */
selectedText => '<div class="text-left">' + (selectedText || '') + '</div>', ɵ7 = /**
 * @param {?} selectedText
 * @return {?}
 */
selectedText => '<div class="text-right">' + (selectedText || '') + '</div>', ɵ8 = /**
 * @param {?} selectedText
 * @return {?}
 */
selectedText => '<div class="text-center">' + (selectedText || '') + '</div>', ɵ9 = /**
 * @param {?} selectedText
 * @return {?}
 */
selectedText => '<div class="text-justify">' + (selectedText || '') + '</div>';
/** @type {?} */
const DefaultTextPositionActions = [
    {
        name: 'text-left',
        action: (ɵ6),
        icon: 'fa-align-left',
        title: 'Text Links'
    },
    {
        name: 'text-right',
        action: (ɵ7),
        icon: 'fa-align-right',
        title: 'Text Rechts'
    },
    {
        name: 'text-center',
        action: (ɵ8),
        icon: 'fa-align-center',
        title: 'Text Links'
    },
    {
        name: 'text-justify',
        action: (ɵ9),
        icon: 'fa-align-justify',
        title: 'Text Justify'
    },
];
const ɵ10 = /**
 * @return {?}
 */
() => '<br>', ɵ11 = /**
 * @param {?} s
 * @return {?}
 */
s => s, ɵ12 = /**
 * @param {?} s
 * @return {?}
 */
s => s, ɵ13 = /**
 * @param {?} s
 * @return {?}
 */
s => s;
/** @type {?} */
const DefaultHtmlActions = [
    {
        name: 'line-break',
        action: (ɵ10),
        icon: 'fa-level-down linebreak',
        // Look for a suitable icon
        title: 'Insert Line Break'
    },
    {
        name: 'horizontal-rule',
        simpleMdeAction: drawHorizontalRule,
        icon: 'fa-minus',
        // Look for a suitable icon
        title: 'Insert Horizontal Line',
        action: (ɵ11)
    },
    {
        name: 'quote',
        simpleMdeAction: toggleBlockquote,
        icon: 'fa-quote-left',
        // Look for a suitable icon
        title: 'Quote',
        action: (ɵ12)
    },
    {
        name: 'code',
        simpleMdeAction: toggleCodeBlock,
        icon: 'fa-code',
        title: 'Code',
        action: (ɵ13)
    },
];
const ɵ14 = /**
 * @param {?} s
 * @return {?}
 */
s => s, ɵ15 = /**
 * @param {?} s
 * @return {?}
 */
s => s, ɵ16 = /**
 * @param {?} s
 * @return {?}
 */
s => s;
/** @type {?} */
const DefaultSimpleMdeActions = [
    {
        name: 'side-by-side',
        simpleMdeAction: toggleSideBySide,
        icon: 'fa-columns no-disabled no-mobile',
        // Look for a suitable icon
        title: 'Toggle Side by Side',
        action: (ɵ14)
    },
    {
        name: 'fullscreen',
        simpleMdeAction: toggleFullScreen,
        icon: 'fa-arrows-alt no-disable no-mobile',
        // Look for a suitable icon
        title: 'Toggle Fullscreen',
        action: (ɵ15)
    },
    '|',
    {
        name: 'guide',
        simpleMdeAction: 'https://simplemde.com/markdown-guide',
        icon: 'fa-question-circle',
        // Look for a suitable icon
        title: 'Markdown Guide',
        action: (ɵ16)
    }
];
/** @type {?} */
const DefaultActions = [
    ...DefaultFontActions,
    '|',
    ...DefaultNumerationActions,
    '|',
    ...DefaultTextPositionActions,
    '|',
    ...DefaultHtmlActions,
    '|',
    ...DefaultSimpleMdeActions
];
/**
 * @param {?} actions
 * @return {?}
 */
function EmbedCustomActionsInDefault(actions) {
    return [
        ...DefaultFontActions,
        '|',
        ...DefaultNumerationActions,
        '|',
        ...DefaultTextPositionActions,
        '|',
        ...actions,
        '|',
        ...DefaultHtmlActions,
        '|',
        ...DefaultSimpleMdeActions
    ];
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/editor/editor.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class EditorComponent {
    constructor() {
        this.inputChange = new EventEmitter();
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        setTimeout((/**
         * @return {?}
         */
        () => {
            this.body.nativeElement.value = this.input;
            /** @type {?} */
            const mdeConfig = {
                element: this.body.nativeElement,
                forceSync: true,
                spellChecker: false,
                toolbar: this.getToolBar()
            };
            if (this.config && this.config.previewRenderer) {
                mdeConfig.previewRender = this.config.previewRenderer;
            }
            this.mde = new SimpleMDE(mdeConfig);
            this.mde.codemirror.on('change', (/**
             * @return {?}
             */
            () => {
                this.emitValue(this.mde.value());
            }));
        }), 0);
    }
    /**
     * @private
     * @return {?}
     */
    getToolBar() {
        /** @type {?} */
        const toolbar = [];
        /** @type {?} */
        let actions = DefaultActions;
        if (this.config && this.config.actions) {
            actions = this.config.actions;
        }
        for (const action of actions) {
            if (action === '|') {
                toolbar.push(action);
            }
            else {
                /** @type {?} */
                const clickAction = !action.simpleMdeAction ? (/**
                 * @return {?}
                 */
                () => { }) : action.simpleMdeAction;
                toolbar.push({
                    name: action.name,
                    title: action.title,
                    className: `fa ${action.icon} x-simplemde-action-${action.name}`,
                    action: clickAction
                });
            }
        }
        return toolbar;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    emitValue(value) {
        this.inputChange.emit(value);
    }
    /**
     * @param {?} $event
     * @return {?}
     */
    toolBarListener($event) {
        /** @type {?} */
        const classList = $event.target.classList;
        if (this.config && this.config.actions) {
            for (const action of this.config.actions) {
                if (action === '|') {
                    continue;
                }
                if (classList.contains(`x-simplemde-action-${action.name}`)) {
                    /** @type {?} */
                    const cm = this.mde.codemirror;
                    /** @type {?} */
                    const selectedText = cm.getSelection();
                    /** @type {?} */
                    const output = action.action(selectedText);
                    if (output instanceof Observable) {
                        output.subscribe((/**
                         * @param {?} outputString
                         * @return {?}
                         */
                        outputString => cm.replaceSelection(outputString)));
                    }
                    else {
                        cm.replaceSelection(output);
                    }
                }
            }
        }
    }
}
EditorComponent.ɵfac = function EditorComponent_Factory(t) { return new (t || EditorComponent)(); };
EditorComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: EditorComponent, selectors: [["angular-simplemde"]], viewQuery: function EditorComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵstaticViewQuery(_c0, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.body = _t.first);
    } }, hostBindings: function EditorComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function EditorComponent_click_HostBindingHandler($event) { return ctx.toolBarListener($event); }, false, ɵngcc0.ɵɵresolveDocument);
    } }, inputs: { input: "input", config: "config" }, outputs: { inputChange: "inputChange" }, decls: 2, vars: 0, consts: [[3, "change"], ["body", ""]], template: function EditorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "textarea", 0, 1);
        ɵngcc0.ɵɵlistener("change", function EditorComponent_Template_textarea_change_0_listener($event) { return ctx.emitValue($event); });
        ɵngcc0.ɵɵelementEnd();
    } }, styles: [""] });
/** @nocollapse */
EditorComponent.ctorParameters = () => [];
EditorComponent.propDecorators = {
    input: [{ type: Input }],
    config: [{ type: Input }],
    inputChange: [{ type: Output }],
    body: [{ type: ViewChild, args: ['body', { static: true },] }],
    toolBarListener: [{ type: HostListener, args: ['document:click', ['$event'],] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(EditorComponent, [{
        type: Component,
        args: [{
                selector: 'angular-simplemde',
                template: "<textarea #body (change)=\"emitValue($event)\"></textarea>\n",
                styles: [""]
            }]
    }], function () { return []; }, { inputChange: [{
            type: Output
        }], 
    /**
     * @param {?} $event
     * @return {?}
     */
    toolBarListener: [{
            type: HostListener,
            args: ['document:click', ['$event']]
        }], input: [{
            type: Input
        }], config: [{
            type: Input
        }], body: [{
            type: ViewChild,
            args: ['body', { static: true }]
        }] }); })();
if (false) {
    /** @type {?} */
    EditorComponent.prototype.input;
    /** @type {?} */
    EditorComponent.prototype.config;
    /** @type {?} */
    EditorComponent.prototype.inputChange;
    /** @type {?} */
    EditorComponent.prototype.body;
    /** @type {?} */
    EditorComponent.prototype.mde;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/angular-simplemde.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AngularSimplemdeModule {
}
AngularSimplemdeModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: AngularSimplemdeModule });
AngularSimplemdeModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function AngularSimplemdeModule_Factory(t) { return new (t || AngularSimplemdeModule)(); }, imports: [[
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AngularSimplemdeModule, { declarations: function () { return [EditorComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [EditorComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AngularSimplemdeModule, [{
        type: NgModule,
        args: [{
                declarations: [EditorComponent],
                imports: [
                    CommonModule
                ],
                exports: [
                    EditorComponent
                ]
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: angular-simplemde.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { AngularSimplemdeModule, DefaultActions, DefaultFontActions, DefaultHtmlActions, DefaultNumerationActions, DefaultSimpleMdeActions, DefaultTextPositionActions, EditorComponent, EmbedCustomActionsInDefault };

//# sourceMappingURL=angular-simplemde.js.map